const HEADERS = [
  '日付',
  'サイト月商',
  '経由売上',
  '伸ばした売上',
];

const FIELDS = [
  'start_at',
  'all_access.conversion_price',
  'all_campaign.conversion_price',
  'contribution_price',
];

const FORMAT = 'YYYYMM';

angular.module('zc')
  .component('zcSiteReportConversionPrice', {
    templateUrl: '/templates/projects.site_reports/conversion_price.html',
    bindings: { project: '<' },
    controller: zcSiteReportConversionPriceController,
  });

zcSiteReportConversionPriceController.$inject = ['$scope', 'ChartV2', 'areaChartV2Config'];
function zcSiteReportConversionPriceController($scope, ChartV2, currencies, areaChartV2Config) {
  const vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize;

  const tooltip = { valueSuffix: $scope.currency.symbol ? $scope.currency.symbol : $scope.currency.suffix };

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.cumulativeDailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    const yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return `conversion-price-${vm.project.apikey}-${yearMonth}.csv`;
  }

  function getCSV() {
    if(!vm.project.cumulativeDailyStats) return;
    let headers;
    let fields;
    if(vm.project.is_abtest) {
      headers = HEADERS;
      fields = FIELDS;
    } else {
      headers = HEADERS.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    const result = [];
    result.push(headers);
    vm.project.cumulativeDailyStats.forEach(stat => {
      const row = fields.map(field => _.get(stat, field));
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    const allAccesses = [];
    const allCampaigns = [];
    const allContributions = [];
    _.each(vm.project.cumulativeDailyStats, stat => {
      const startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.conversion_price]);
      allCampaigns.push([startAt, stat.all_campaign.conversion_price]);
      allContributions.push([startAt, stat.contribution_price]);
    });
    const chart = new ChartV2(areaChartV2Config);
    vm.chartConfig = chart.getConfig();
    chart.addSeries({ name: 'サイト月商', data: allAccesses, tooltip });
    chart.addSeries({ name: '経由売上', data: allCampaigns, tooltip });
    if(!vm.project.is_abtest) return;
    chart.addSeries({ name: '伸ばした売上', data: allContributions, tooltip });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.site_reports/conversion_price.controller.js